import React from 'react'
import { InvestorFormWithId } from './AdminInvestorsFields'
import Typography from '@mui/material/Typography'
import { formatMoney } from '../../../../packages/utils/numberFormatters'
import { useAppLocale } from '../../../../i18n/localeUtils'

export interface InvestorsFieldsSanityCheckProps {
    warnings: {
        warningOfferedUnits: boolean
        totalOfferingCash: number | null
    }
    totals: {
        cash: number
        percentage: number
        level0: number
        level1: number
    }
}

export function InvestorsFieldsSanityCheck({
    investors,
    sanityChecker,
}: {
    investors: InvestorFormWithId[]
    sanityChecker: (investors: InvestorFormWithId[]) => InvestorsFieldsSanityCheckProps
}) {
    const { intlLocale: locale } = useAppLocale()
    const { warnings, totals } = sanityChecker(investors)
    return (
        <>
            {warnings.warningOfferedUnits && (
                <Typography variant='body2' color='error'>
                    varning totalt erbjudande: {formatMoney(totals.cash, { locale, decimals: 0 })}, vs{' '}
                    {formatMoney(warnings.totalOfferingCash, { locale, decimals: 0 })}
                </Typography>
            )}
        </>
    )
}
